<template>
  <div
    id="shoppermanagement"
    v-if="
      globals.isAccessAllowed('LoopOp_Shopper_ReadAll') &&
      !(
        feature.isAudiTarget &&
        (globals.isLeadAgencyUser || globals.isAudiUser)
      )
    "
  >
    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="shoppermanagement-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            id="shopper-management-refresh-button"
            class="btn btn-raised btn-top-bar"
            @click="getShoppersList()"
            :disabled="!refreshEnabled"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.SM0000 }}
          </button>
          <button
            id="shopper-management-create-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Shopper_Create')"
            @click="
              (editShopperDialogModeAdd = true),
                (selectedShopper = {}),
                openEditShopperDialog()
            "
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.SM0001 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Shopper_Read')"
            @click="(editShopperDialogModeAdd = false), openEditShopperDialog()"
            :disabled="!isShopperSelected()"
          >
            <i class="material-icons md-36">edit</i>
            <br />
            {{ lang.SM0002 }}
          </button>
          <button
            id="shopper-management-delete-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Shopper_Delete')"
            @click="openDeleteShopperConfirmationDialog()"
            :disabled="!isShopperSelected()"
          >
            <i class="material-icons md-36">clear</i>
            <br />
            {{ lang.SM0017 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="
              globals.isAccessAllowed('LoopOp_Password_ChangePassword') &&
              globals.isAccessAllowed('LoopOp_Password_ValidatePassword') &&
              !globals.isAgencyUser
            "
            :disabled="!isShopperSelected()"
            @click="openChangePasswordDialog()"
          >
            <i class="material-icons md-36">vpn_key</i>
            <br />
            {{ lang.SM0018 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="openCustomPropertyDialog()"
            v-if="
              globals.isAccessAllowed('LoopOp_ShopperProperties_ReadAll') &&
              !globals.isAgencyUser
            "
          >
            <i class="material-icons md-36">assignment</i>
            <br />
            {{ lang.SM0003 }}
          </button>
          <!-- TODO: export -->
          <!-- <button
            class="btn btn-raised btn-top-bar"
            :disabled="!isShopperSelected()"
            @click="openShopperExportConfirmationDialog()"
          >
            <i class="material-icons md-36">file_download</i>
            <br>
            {{lang.SM0020}}
          </button>-->
          <router-link
            tag="button"
            class="btn btn-raised btn-top-bar"
            v-if="
              globals.isAccessAllowed(
                'LoopOp_ShopperSurveyInstances_ReadAll'
              ) && !feature.isAudiTarget
            "
            :disabled="!isShopperSelected()"
            :to="`shoppermanagement/checks?selectedShopperGuid=${selectedShopper.ShopperGuid}`"
          >
            <i class="material-icons md-36">list</i>
            <br />
            {{ lang.SM0025 }}
          </router-link>
        </div>
      </div>
      <div class="panel-body">
        <div class="col-lg-7">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.SM0004"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getShoppersList()"
            />
          </div>
        </div>
        <div class="col-lg-5 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.SM0005 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: !pageCount || selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SM0006 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{
                disabled: !pageCount || selectedPage == pageCount,
              }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SM0007 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="shoppersTotalElementsCounter">{{
                totalElementsCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="shoppersTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.SM0035 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <table class="table table-striped table-hover main-table">
          <thead>
            <tr>
              <!-- Add table headers here -->
              <!-- The table sort is triggered by click on the header -->              
              <th style="width: 6%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('ShopperId')"
                >
                  {{ lang.SA0021 }}
                  <span
                    v-if="showSortArrow('ShopperId', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('ShopperId', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('Username')"
                >
                  {{ lang.SM0010 }}
                  <span
                    v-if="showSortArrow('Username', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('Username', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('FirstName')"
                >
                  {{ lang.SM0008 }}
                  <span
                    v-if="showSortArrow('FirstName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('FirstName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('LastName')"
                >
                  {{ lang.SM0009 }}
                  <span
                    v-if="showSortArrow('LastName', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('LastName', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 5%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('Gender')"
                >
                  {{ lang.SM0011 }}
                  <span
                    v-if="showSortArrow('Gender', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('Gender', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('PostalCode')"
                >
                  {{ lang.SM0012 }}
                  <span
                    v-if="showSortArrow('PostalCode', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('PostalCode', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('City')"
                >
                  {{ lang.SM0013 }}
                  <span
                    v-if="showSortArrow('City', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('City', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 5%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('CountryCode')"
                >
                  Land
                  <span
                    v-if="showSortArrow('CountryCode', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('CountryCode', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 14%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('Email')"
                >
                  {{ lang.SM0014 }}
                  <span
                    v-if="showSortArrow('Email', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('Email', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 5%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('Age')"
                >
                  {{ lang.SM0015 }}
                  <span
                    v-if="showSortArrow('Age', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('Age', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('NumberOfChecks')"
                >
                  {{ lang.SM0016 }}
                  <span
                    v-if="showSortArrow('NumberOfChecks', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('NumberOfChecks', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 5%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="orderTableByColumn('Active')"
                >
                  {{ lang.SM0034 }}
                  <span
                    v-if="showSortArrow('Active', true)"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="showSortArrow('Active', false)"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
            </tr>
            <tr class="table-filters">
              <th class="nopadding" style="width: 6%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.ShopperId"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.Username"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.FirstName"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.LastName"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 5%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.Gender"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.PostalCode"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.City"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 5%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.CountryCode"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 14%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.Email"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 5%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.SM0019"
                    v-model="filterStrings.Age"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    v-model="filterStrings.NumberOfChecks"
                    :placeholder="lang.SM0019"
                    @keyup.enter="(selectedPage = 1), getShoppersList()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 5%">
                <div class="form-group filterbar">
                  <a
                    role="button"
                    @click="updateActiveFilter(), getShoppersList()"
                  >
                    <div
                      class="cb-active-filter-container"
                      v-if="filterStrings.Active === 'true'"
                    >
                      <i class="material-icons md-24">check_box</i>
                    </div>
                    <div
                      class="cb-active-filter-container"
                      v-else-if="filterStrings.Active === 'false'"
                    >
                      <i class="material-icons md-24"
                        >check_box_outline_blank</i
                      >
                    </div>
                    <div class="cb-active-filter-container" v-else>
                      <i class="material-icons md-24"
                        >indeterminate_check_box</i
                      >
                    </div>
                  </a>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar">
            <!-- TODO: LoopOp_ShopperBankDetails_ReadAll -->
            <tr
              role="button"
              v-for="shopper in shoppersList"
              :key="shopper.ShopperGuid"
              @click="selectedShopper = shopper"
              @dblclick="
                !globals.isAccessAllowed('LoopOp_Shopper_Read') ||
                  ((editShopperDialogModeAdd = false), openEditShopperDialog())
              "
              :class="{
                info: shopper.ShopperGuid === selectedShopper.ShopperGuid,
              }"
            >
              <td style="width: 6%">{{ shopper.ShopperId }}</td>
              <td style="width: 10%">{{ shopper.Username }}</td>
              <td style="width: 10%">{{ shopper.FirstName }}</td>
              <td style="width: 10%">{{ shopper.LastName }}</td>
              <td style="width: 5%">{{ shopper.Gender }}</td>
              <td style="width: 10%">{{ shopper.PostalCode }}</td>
              <td style="width: 10%">{{ shopper.City }}</td>
              <td style="width: 5%">{{ shopper.CountryCode }}</td>
              <td style="width: 14%">{{ shopper.Email }}</td>
              <td style="width: 5%">{{ shopper.Age }}</td>
              <td style="width: 10%">{{ shopper.NumberOfChecks }}</td>
              <td style="width: 5%; padding: 6px 0 0 0">
                <i class="material-icons md-24 text-green" v-if="shopper.Active"
                  >done</i
                >
                <i class="material-icons md-24 text-red" v-else>clear</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <shopper-edit-modal
      :showDialog="showEditShopperDataDialog"
      :occupationalGroupList="occupationalGroupList"
      :dialogModeAdd="editShopperDialogModeAdd"
      :selectedShopperGuid="selectedShopper.ShopperGuid"
      @dialogClosed="onEditShopperDataClosed"
      @dialogDataSaved="onEditShopperDialogDataSaved"
    ></shopper-edit-modal>

    <custom-property-edit-modal
      :showDialog="showCustomPropertyEditDialog"
      @dialogClosed="onCustomPropertyDialogClosed"
    ></custom-property-edit-modal>

    <change-password-dialog
      :showDialog="showChangePasswordDialog"
      :userGuid="selectedShopper.ShopperGuid"
      :userName="selectedShopper.Username"
      @dialogClosed="onChangePasswordDialogClosed"
    ></change-password-dialog>
  </div>
</template>

<script>
import ShopperEditModal from "./ShopperEditModal";
import CustomPropertyEditModal from "./CustomPropertyEditModal";
import ChangePasswordDialog from "../Tools/Dialogs/ChangePasswordDialog";

export default {
  name: "ShopperManagement",
  components: {
    "shopper-edit-modal": ShopperEditModal,
    "custom-property-edit-modal": CustomPropertyEditModal,
    "change-password-dialog": ChangePasswordDialog,
  },
  data() {
    return {
      searchString: "",
      pageSize: 20,
      selectedPage: 1,
      pageCount: 0,
      totalElementsCount: 0,
      refreshEnabled: false,
      shoppersList: [],
      currentSort: { key: "FirstName", asc: true },
      showEditShopperDataDialog: false,
      showCustomPropertyEditDialog: false,
      occupationalGroupList: {},
      selectedShopper: {},
      editShopperDialogModeAdd: true,
      showChangePasswordDialog: false,
      filterStrings: {
        Search: "",
        ShopperId: "",
        Username: "",
        FirstName: "",
        LastName: "",
        Gender: "",
        PostalCode: "",
        City: "",
        CountryCode: "",
        Email: "",
        Age: "",
        NumberOfChecks: "",
        Active: "",
      },
      lang: {
        SM0000: "Refresh",
        SM0001: "New Shopper",
        SM0002: "Edit",
        SM0003: "Properties",
        SM0004: "Search...",
        SM0005: "Items per page",
        SM0006: "First page",
        SM0007: "Last page",
        SM0008: "First Name",
        SM0009: "Last Name",
        SM0010: "Username",
        SM0011: "Gender",
        SM0012: "Postal Code",
        SM0013: "City",
        SM0014: "Email",
        SM0015: "Age",
        SM0016: "Number of checks",
        SM0017: "Delete",
        SM0018: "Password",
        SM0019: "Search",
        SM0020: "Export",
        SM0021: "Shopper Export",
        SM0022: "Download",
        SM0023: "Cancel",
        SM0024: "Export Selected Shopper",
        SM0025: "View Shopper Checks",
        SM0026: "Assignment",
        SM0027: "Delete Shoppper",
        SM0028: "Yes",
        SM0029: "No",
        SM0030: "Do you really want to delete this shopper?",
        SM0031: "ID",
        SM0032: "First name",
        SM0033: "Last name",
        SM0034: "Active",
        SM0035: "Total shoppers count",
        SA0021: "ShopperID"
      },
    };
  },
  mounted() {
    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getOccupationalGroupList((callbackData) => {
        this.occupationalGroupList = callbackData;
      });
    }
    this.getShoppersList();
    // Sets the new table height after the window got resized
    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setTableHeight);

    // Register global events
    // Export
    this.globals.$off("ExportShopperYesConfirmation");
    this.globals.$on("ExportShopperYesConfirmation", () => {
      this.exportSelectedShopper();
    });

    // Delete shopper
    this.globals.$off("DeleteShopperYesConfirmation");
    this.globals.$on("DeleteShopperYesConfirmation", () => {
      this.deleteSelectedShopper();
    });
  },
  destroyed() {
    this.writeComponentSettingsToStore();
    $(window).off("resize", this.setTableHeight);
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setTableHeight);
      this.globals.getOccupationalGroupList((callbackData) => {
        this.occupationalGroupList = callbackData;
      });
    },
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#shoppermanagement-top-panel").height() +
          $("#app-navbar").height() +
          $("#shoppermanagement .main-table > thead").height() +
          47;
        $("#shoppermanagement .main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/shopperManagement"];
      if (storedData) {
        for (let key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/shopperManagement", {
        selectedShopper: this.selectedShopper,
        pageSize: this.pageSize,
        selectedPage: this.selectedPage,
        currentSort: this.currentSort,
        filterStrings: this.filterStrings,
      });
    },
    getShoppersList() {
      let queryString = `api/Shopper/Get?page_size=${this.pageSize}&page=${
        this.selectedPage
      }&sort_column=${this.currentSort.key}&sort_order=${
        this.currentSort.asc ? "asc" : "desc"
      }`;
      queryString = encodeURI(queryString);

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        if (key === "Active" && value.length > 0) return true;
        return value.length > 0;
      });
      if (typeof filter.Active === "string")
        filter.Active = filter.Active === "true" ? true : false;

      this.refreshEnabled = false;

      $.ajax({
        method: "POST",
        url: queryString,
        data: _.isEmpty(filter) ? "" : JSON.stringify({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.shoppersList = data[0].Shoppers;
          this.pageCount = data[0].Page_Count;
          this.totalElementsCount = data[0].Count;
        },
        error: () => {
          console.error("Shopper data request failed in getShoppersList()");
          this.globals.showErrorSnackbar("Shopper data access failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    updateActiveFilter() {
      if (!this.filterStrings.Active) this.filterStrings.Active = "true";
      else if (this.filterStrings.Active === "true")
        this.filterStrings.Active = "false";
      else this.filterStrings.Active = "";
    },
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getShoppersList();
    },
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    showSortArrow(key, asc) {
      return this.currentSort.key === key && this.currentSort.asc === asc;
    },
    orderTableByColumn(orderProp) {
      if (!orderProp && !this.currentSort.key) return;

      if (orderProp) {
        this.currentSort.key === orderProp
          ? (this.currentSort.asc = !this.currentSort.asc)
          : (this.currentSort = { asc: true, key: orderProp });
      }
      this.getShoppersList();
    },
    isShopperSelected() {
      return !!this.selectedShopper.ShopperGuid;
    },
    openEditShopperDialog() {
      this.showEditShopperDataDialog = true;
    },
    onEditShopperDataClosed() {
      this.showEditShopperDataDialog = false;
      // this.getShoppersList();
    },
    openCustomPropertyDialog() {
      this.showCustomPropertyEditDialog = true;
    },
    onCustomPropertyDialogClosed() {
      this.showCustomPropertyEditDialog = false;
    },
    openShopperExportConfirmationDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getExportShopperData()
      );
    },
    // TODO:
    getExportShopperData() {
      return {
        initiator: "ExportShopper",
        confirmationTitle: this.lang.SM0021,
        yesButtonText: this.lang.SM0022,
        noButtonText: this.lang.SM0023,
        htmlText: `<p><b>${this.lang.SM0024}</b></p>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.SM0031}</label>
          <label class="col-md-8 text-black">${this.selectedShopper.ShopperId}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.SM0032}</label>
          <label class="col-md-8 text-black">${this.selectedShopper.FirstName}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.SM0033}</label>
          <label class="col-md-8 text-black">${this.selectedShopper.LastName}</label>
        </div>`,
      };
    },
    // TODO: implement export api
    exportSelectedShopper() {
      console.log("export");
    },
    onEditShopperDialogDataSaved() {
      this.getShoppersList();
    },
    openDeleteShopperConfirmationDialog() {
      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getDeleteDialogData()
      );
    },
    getDeleteDialogData() {
      let shopper = this.selectedShopper;
      return {
        initiator: "DeleteShopper",
        confirmationTitle: this.lang.SM0027,
        colorRed: true,
        yesButtonText: this.lang.SM0028,
        noButtonText: this.lang.SM0029,
        htmlText: `<p><b>${this.lang.SM0030}</b></p>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.SM0031}</label>
          <label class="col-md-8 text-black">${shopper.ShopperId}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.SM0032}</label>
          <label class="col-md-8 text-black">${shopper.FirstName}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.SM0033}</label>
          <label class="col-md-8 text-black">${shopper.LastName}</label>
        </div>`,
      };
    },
    deleteSelectedShopper() {
      let queryString = `api/Shopper/${this.selectedShopper.ShopperGuid}`;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: (data) => {
          this.globals.showSuccessSnackbar("Shopper deletion successful");
          this.getShoppersList();
        },
        error: () => {
          console.error("Shopper deletion failed in deleteSelectedShopper()");
          this.globals.showErrorSnackbar("Shopper deletion failed");
        },
      });
    },
    openChangePasswordDialog() {
      this.showChangePasswordDialog = true;
    },
    onChangePasswordDialogClosed() {
      this.showChangePasswordDialog = false;
    },
  },
};
</script>

<style scoped>
.cb-active-filter-container {
  margin-top: 7px;
  color: var(--color-primary-input);
}
</style>



// WEBPACK FOOTER //
// ShopperManagement.vue?36e66009